import EntityModal from './EntityModal';

export default EntityModal;
